import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpenglComponent } from './simple-icons-opengl.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpenglComponent ],
    exports:      [ SimpleIconsOpenglComponent ],
    bootstrap:    []
})
export class SimpleIconsOpenglModule {}
